import React, { useMemo, useState } from 'react'
import Breadcrumb from '../../components/common/Breadcrumb'
import ReactDataTable from 'react-data-table-component';
import {
    mastercard,
    paypal,
    visacard,
} from '../../assets/images';
import Loading from '../../components/common/Loading';

export default function Expense() {
    const [loading, setLoading] = useState(false)
    setLoading(false);
    const columnsFilter = [
        {
            name: 'Item',
            selector: row => row.item,
            sortable: true,
        },
        {
            name: 'Order By',
            selector: row => row.orderBy,
            sortable: true,
        },
        {
            name: 'From',
            selector: row => row.from,
            sortable: true,
        },
        {
            name: 'Date',
            selector: row => row.date,
            sortable: true,
        },
        {
            name: 'Paid By',
            selector: row => row.paidBy,
        },
        {
            name: 'Status',
            selector: row => row.status,
        },
        {
            name: 'Amount',
            selector: row => row.amount,
            sortable: true,
        },
    ];

    const dataFilter = [
        {
            item: 'Dell Monitor 22 inch',
            orderBy: 'Ava Alexander',
            from: 'Flipkart India',
            date: '07 March, 2021',
            paidBy: <img src={mastercard} alt='paymrnt type' className='w-[50px]' />,
            status: <span className='inline-block py-1 px-2 uppercase text-[10.5px]/[12px] bg-success text-white rounded'>Approved</span>,
            amount: '$205'
        },
        {
            item: 'HP Computer',
            orderBy: 'Marshall Nichols',
            from: 'Amazon',
            date: '07 March, 2021',
            paidBy: <img src={paypal} alt='paymrnt type' className='w-[50px]' />,
            status: <span className='inline-block py-1 px-2 uppercase text-[10.5px]/[12px] bg-yellow text-white rounded'>Pending</span>,
            amount: '$205'
        },
        {
            item: 'Logitech USB Mouse, Keyboard',
            orderBy: 'Marshall Nichols',
            from: 'Amazon',
            date: '28 July, 2021',
            paidBy: <img src={paypal} alt='paymrnt type' className='w-[50px]' />,
            status: <span className='inline-block py-1 px-2 uppercase text-[10.5px]/[12px] bg-success text-white rounded'>Approved</span>,
            amount: '$4,205'
        },
        {
            item: 'MacBook Pro',
            orderBy: 'Debra Stewart',
            from: 'Amazon',
            date: '17 Jun, 2021',
            paidBy: <img src={visacard} alt='paymrnt type' className='w-[50px]' />,
            status: <span className='inline-block py-1 px-2 uppercase text-[10.5px]/[12px] bg-success text-white rounded'>Approved</span>,
            amount: '$800'
        },
        {
            item: 'Zebronics Desktop',
            orderBy: 'Marshall Nichols',
            from: 'ebay UK',
            date: '22 July, 2021',
            paidBy: <img src={paypal} alt='paymrnt type' className='w-[50px]' />,
            status: <span className='inline-block py-1 px-2 uppercase text-[10.5px]/[12px] bg-yellow text-white rounded'>Pending</span>,
            amount: '$355'
        },
    ]

    const [filterText, setFilterText] = React.useState('');
    const [resetPaginationToggle, setResetPaginationToggle] = React.useState(false);
    const filteredItems = dataFilter.filter(
        item =>
            item.item.toLowerCase().includes(filterText.toLowerCase()) ||
            item.orderBy.toLowerCase().includes(filterText.toLowerCase()) ||
            item.from.toLowerCase().includes(filterText.toLowerCase()) ||
            item.date.toLowerCase().includes(filterText.toLowerCase()) ||
            item.amount.toLowerCase().includes(filterText.toLowerCase())
    );

    const subHeaderComponentMemo = useMemo(() => {
        const handleClear = () => {
            if (filterText) {
                setResetPaginationToggle(!resetPaginationToggle);
                setFilterText('');
            }
        };

        return (
            <div className='flex gap-5 mb-10 w-full justify-end'>
                <div className='relative w-full max-w-[221px]'>
                    <input
                        type='text'
                        id='search'
                        value={filterText}
                        onChange={e => setFilterText(e.target.value)}
                        placeholder='Search here...'
                        className='bg-bg-light border border-border w-full py-[6px] px-3 min-h-[40px] rounded-[4px] placeholder:text-text-secondary focus:outline-none'
                    />
                </div>
                <button onClick={handleClear} className="btn btn-danger">
                    Clear
                </button>
            </div>
        );
    }, [filterText, resetPaginationToggle]);

    return (
        <>
            <Breadcrumb title="Expenses" path="Accounts / Expenses" />
            <div className='bg-bg-dark rounded-lg shadow-light md:p-20 p-15'>
            <div className="react-data-table">
          {loading ? (
            <Loading />
          ) : (
            <ReactDataTable
              columns={columnsFilter}
              data={filteredItems}
              pagination
              paginationResetDefaultPage={resetPaginationToggle}
              subHeader
              subHeaderComponent={subHeaderComponentMemo}
            />
          )}
        </div>
            </div>
        </>
    )
}
